import React from "react";
import { Row, Col } from "antd";
import { useIntl } from "react-intl";

import ImportFile from "../../components/import/importFile";
import ImportHeader from "../../components/import/importHeader";
import AddressImportInstructions from "../../components/addressImport/addressImportInstructions";

const AddressImport = () => {
  const intl = useIntl();
  return (
    <Row>
      <Col>
        <ImportHeader
          what={intl.formatMessage({
            id: "customer.genitivMultiple",
            defaultMessage: "zákazníků",
          })}
        />
        <ImportFile
          entity="address"
          filePrefix="customer"
          whatFourth={intl.formatMessage({
            id: "customer.genitiv",
            defaultMessage: "zákazníka",
          })}
        >
          <AddressImportInstructions />
        </ImportFile>
      </Col>
    </Row>
  );
};

export default AddressImport;
